import {useFormikContext} from 'formik'
import {CrudProvider} from '../../../../services/loggedin/CrudContext'
import {FormComponent} from '../../../parts/crud/Form'
import clsx from 'clsx'
import Select from 'react-select'
import {useEffect, useState} from 'react'

export const FormUser = () => {
  //const { setFieldValue } = useFormikContext();

  const [disableTenant, setDisableTenant] = useState(-1)

  return (
    <>
      <CrudProvider api='users'>
        <FormComponent
          fetch={{roles: 'users/roles', tenants: 'users/tenants'}}
          redirect='/user'
          text_modificato='Utente modificato con successo'
          text_nuovo='Utente creato con successo'
        >
          {(formik, data, remoteErrors, isEdit) => (
            <>
              <div className='row mb-6'>
                <div className='col-md-6'>
                  <div className='form-group'>
                    <label htmlFor='roleId' className='required fw-bold fs-6'>
                      Ruolo
                    </label>
                    <select
                      className={clsx('form-select', {
                        'is-invalid': formik.touched.roleId && formik.errors.roleId,
                        'is-valid': formik.touched.roleId && !formik.errors.roleId,
                      })}
                      id='roleId'
                      name='roleId'
                      onChange={(e) => {
                        if (e.target.value === '1' || e.target.value === '') {
                          formik.setFieldValue('groups', [])
                          setDisableTenant(1)
                        } else {
                          setDisableTenant(0)
                        }
                        return formik.handleChange(e)
                      }}
                      value={formik.values.roleId}
                    >
                      <option value=''>Scegli un ruolo</option>
                      {data &&
                        data.roles &&
                        data.roles.map((role: any) => (
                          <option key={role.roleId} value={role.roleId}>
                            {role.role}
                          </option>
                        ))}
                    </select>
                    {formik.touched.roleId && formik.errors.roleId ? (
                      <em className='text-danger'>{formik.errors.roleId}</em>
                    ) : null}
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='form-group'>
                    <label htmlFor='groups' className='required fw-bold fs-6'>
                      Tenant
                    </label>
                    <Select
                      isMulti
                      name='groups'
                      isDisabled={
                        disableTenant !== -1
                          ? disableTenant === 1
                          : formik.values.roleId === 1 ||
                            formik.values.roleId === '1' ||
                            formik.values.roleId === undefined
                      }
                      options={data.tenants}
                      className={clsx('basic-multi-select ', {
                        'is-invalid': remoteErrors.groups !== undefined,
                        'is-valid': remoteErrors !== undefined && remoteErrors.groups === undefined,
                      })}
                      classNamePrefix='select'
                      onChange={(selectedOption) => formik.setFieldValue('groups', selectedOption)}
                      value={formik.values.groups}
                    />
                  </div>
                  {remoteErrors.groups !== undefined ? (
                    <em className='text-danger'>{remoteErrors.groups}</em>
                  ) : null}
                </div>
              </div>
              <div className='row mb-6'>
                <div className='col-md-6'>
                  <div className='form-group'>
                    <label htmlFor='name' className='required fw-bold fs-6'>
                      Nome completo
                    </label>
                    <input
                      type='text'
                      className={clsx('form-control ', {
                        'is-invalid': formik.touched.name && formik.errors.name,
                        'is-valid': formik.touched.name && !formik.errors.name,
                      })}
                      id='name'
                      {...formik.getFieldProps('name')}
                    />
                    {formik.touched.name && formik.errors.name ? (
                      <em className='text-danger'>{formik.errors.name}</em>
                    ) : null}
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='form-group'>
                    <label htmlFor='mobile' className='required fw-bold fs-6'>
                      Numero di telefono
                    </label>
                    <input
                      type='text'
                      className={clsx('form-control ', {
                        'is-invalid': formik.touched.mobile && formik.errors.mobile,
                        'is-valid': formik.touched.mobile && !formik.errors.mobile,
                      })}
                      id='mobile'
                      name='mobile'
                      onChange={formik.handleChange}
                      value={formik.values.mobile}
                    />
                    {formik.touched.mobile && formik.errors.mobile ? (
                      <em className='text-danger'>{formik.errors.mobile}</em>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className='row mb-6'>
                <div className='col-md-12'>
                  <div className='form-group'>
                    <label htmlFor='email' className='required fw-bold fs-6'>
                      Email
                    </label>
                    <input
                      type='text'
                      className={clsx('form-control ', {
                        'is-invalid':
                          (formik.touched.email && formik.errors.email) ||
                          remoteErrors.email !== undefined,
                        'is-valid':
                          formik.touched.email &&
                          !formik.errors.email &&
                          remoteErrors.email === undefined,
                      })}
                      id='email'
                      name='email'
                      onChange={formik.handleChange}
                      value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <em className='text-danger'>{formik.errors.email}</em>
                    ) : null}
                    {remoteErrors.email !== undefined ? (
                      <em className='text-danger'>{remoteErrors.email}</em>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-md-6'>
                  <div className='form-group'>
                    <label
                      htmlFor='password'
                      className={clsx(' fw-bold fs-6', {
                        required: !isEdit,
                      })}
                    >
                      Password
                    </label>
                    <input
                      type='password'
                      className={clsx('form-control ', {
                        'is-invalid':
                          (formik.touched.password && formik.errors.password) ||
                          remoteErrors.password !== undefined,
                        'is-valid':
                          formik.touched.password &&
                          !formik.errors.password &&
                          remoteErrors.password === undefined,
                      })}
                      id='password'
                      {...formik.getFieldProps('password')}
                    />
                    {formik.touched.password && formik.errors.password ? (
                      <em className='text-danger'>{formik.errors.password}</em>
                    ) : null}
                    {remoteErrors.password !== undefined ? (
                      <em className='text-danger'>{remoteErrors.password}</em>
                    ) : null}
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='form-group'>
                    <label
                      htmlFor='password_confirm'
                      className={clsx(' fw-bold fs-6', {
                        required: !isEdit,
                      })}
                    >
                      Conferma password
                    </label>
                    <input
                      type='password'
                      className={clsx('form-control ', {
                        'is-invalid':
                          (formik.touched.password_confirm && formik.errors.password_confirm) ||
                          remoteErrors.password_confirm !== undefined,
                        'is-valid':
                          formik.touched.password_confirm &&
                          !formik.errors.password_confirm &&
                          remoteErrors.password_confirm === undefined,
                      })}
                      id='password_confirm'
                      name='password_confirm'
                      onChange={formik.handleChange}
                      value={formik.values.password_confirm}
                    />
                    {formik.touched.password_confirm && formik.errors.password_confirm ? (
                      <em className='text-danger'>{formik.errors.password_confirm}</em>
                    ) : null}
                    {remoteErrors.password_confirm !== undefined ? (
                      <em className='text-danger'>{remoteErrors.password_confirm}</em>
                    ) : null}
                  </div>
                </div>
              </div>
            </>
          )}
        </FormComponent>
      </CrudProvider>
    </>
  )
}
